module.exports = __webpack_public_path__ + "img/andvantage-one.052f6621.png";